/* eslint-disable max-len */
import appExplorationCoach from './source/app-exploration/coach.png'
import appExplorationCoachDark from './source/app-exploration/coach-dark.png'
import appExplorationGoals from './source/app-exploration/goals.png'
import appExplorationGoalsDark from './source/app-exploration/goals-dark.png'
import appExplorationHome from './source/app-exploration/home.png'
import appExplorationHomeDark from './source/app-exploration/home-dark.png'
import appExplorationLog from './source/app-exploration/log.png'
import appExplorationLogDark from './source/app-exploration/log-dark.png'
import appExplorationNora from './source/app-exploration/nora.png'
import appExplorationNoraDark from './source/app-exploration/nora-dark.png'
import arrowRight from './source/arrow-right.png'
import bandage from './source/bandage.png'
import bluetooth from './source/bluetooth.png'
import blurredArcIndicatorsDark from './source/blurred-arc-indicators-dark.jpg'
import blurredArcIndicators from './source/blurred-arc-indicators.jpg'
import blurredDialChartDark from './source/blurred-dial-chart-dark.jpg'
import blurredDialChart from './source/blurred-dial-chart.jpg'
import blurredGlucoseChartDark from './source/blurred-glucose-chart-dark.jpg'
import blurredGlucoseChart from './source/blurred-glucose-chart.jpg'
import boxContent from './source/box-content.png'
import calendarHeart from './source/calendar-heart.png'
import calendar from './source/calendar.png'
import cgmG6 from './source/cgm-g6.png'
import cgmG7 from './source/cgm-g7.png'
import cgmLibre14day from './source/cgm-libre14day.png'
import cgmLibre2 from './source/cgm-libre2.png'
import cgmLibre3 from './source/cgm-libre3.png'
import cgmStelo from './source/cgm-stelo.png'
import cgmSteloDouble from './source/cgm-stelo-double.png'
import labs from './source/labs.png'
import coursesModuleDescription from './source/courses-module-description.png'
import dangerSign from './source/danger-sign.png'
import dexcomG6Box from './source/dexcom-g6-box.png'
import dexcomG7Box from './source/dexcom-g7-box.png'
import dexcomSteloBox from './source/dexcom-stelo-box.png'
import glucoseChartMeal from './source/glucose-chart-meal.png'
import glucoseEducation from './source/glucose-education.png'
import glucoseScoreWheelDark from './source/glucose-score-wheel-dark.png'
import glucoseScoreWheel from './source/glucose-score-wheel.png'
import goalsCircles from './source/goals-circles.png'
import healthConnectPermissionLight from './source/health-connect-permission-light.png'
import healthConnectPermissionDark from './source/health-connect-permission-dark.png'
import healthKitPermissionDark from './source/health-kit-permission-dark.png'
import healthKitPermissionLight from './source/health-kit-permission-light.png'
import hourglass from './source/hourglass.png'
import imageMeal1 from './source/image-meal-1.jpg'
import imageMeditate1 from './source/image-meditate-1.jpg'
import imageReadyToScan1 from './source/image-ready-to-scan.png'
import installCgm from './source/install-cgm.png'
import knowledgeBaseDark from './source/knowledge-base-dark.png'
import knowledgeBaseLight from './source/knowledge-base-light.png'
import libre1 from './source/libre1.png'
import libre2 from './source/libre2.png'
import libre3 from './source/libre3.png'
import lingoBox from './source/lingo-box.png'
import libreLogoNutrisense from './source/libre-logo-nutrisense.png'
import libre3LogoNutrisense from './source/libre3-logo-nutrisense.png'
import marketplaceByos from './source/marketplace-byos.png'
import marketplaceCgmPrograms from './source/marketplace-cgm-programs.jpeg'
import marketplaceCoachSupport from './source/marketplace-coach-support.png'
import marketplaceHandWPatches from './source/marketplace-hand-w-patches.png'
import marketplaceIphoneWApp from './source/marketplace-iphone-w-app.png'
import marketplaceIphoneWAppVertical from './source/marketplace-iphone-w-app-vertical.png'
import marketplaceNN from './source/marketplace-nn.png'
import marketplaceNnVideoCalls from './source/marketplace-nn-video-calls.png'
import marketplaceNutritionistSupport from './source/marketplace-nutritionist-support.png'
import marketplaceRunner from './source/marketplace-runner.jpg'
import marketplaceSensors from './source/marketplace-sensors.png'
import membershipBlurred from './source/membership-blurred.jpg'
import membershipBlurredDark from './source/membership-blurred-dark.jpg'
import membershipCardBg from './source/membership-card-bg.png'
import mfpIntegrationDark from './source/mfp-integration-dark.png'
import mfpIntegrationLight from './source/mfp-integration-light.png'
import notificationsPermissionDark from './source/notifications-permission-dark.png'
import notificationsPermissionLight from './source/notifications-permission-light.png'
import nutritionist from './source/nutritionist.jpeg'
import nutrisenseSteloConnection from './source/nutrisense-stelo-connection.png'
import onboardingAppFeatures from './source/onboarding/app-features.png'
import onboardingStart from './source/onboarding/start.jpg'
import onboardingCoachingTeam from './source/onboarding/coaching-team.png'
import onboardingLabTesting from './source/onboarding/lab-testing.jpg'
import onboardingLabTestingDark from './source/onboarding/lab-testing-dark.jpg'
import onboardingLabPanels from './source/onboarding/lab-panels-light.jpg'
import onboardingLabPanelsDark from './source/onboarding/lab-panels-dark.jpg'
import onboardingMicrobiomeTest from './source/onboarding/microbiome-test.jpg'
import onboardingMicrobiomeTestDark from './source/onboarding/microbiome-test-dark.jpg'
import onboardingInsurance from './source/onboarding/insurance.png'
import onboardingSteloCgm from './source/onboarding/stelo-cgm.jpg'
import onboardingSteloCgmDark from './source/onboarding/stelo-cgm-dark.jpg'
import nutritionCoaching from './source/nutrition-coaching.jpg'
import nutritionCoachingDark from './source/nutrition-coaching-dark.jpg'
import stressManagement from './source/stress-management.jpg'
import stressManagementDark from './source/stress-management-dark.jpg'
import runnerFull from './source/runner_full.jpg'
import shower from './source/shower.png'
import videoCall from './source/video-call.jpeg'
import freeTrialOffer from './source/free-trial-offer.png'
import nutritionGuidance from './source/nutrition-guidance.png'
import freeConsultation from './source/free-consultation.png'
import sensorActivatedNutritionGuidance from './source/sensor-activated-nutrition-guidance.png'
import poweredBySteloLogo from './source/powered-by-stelo-logo.png'
import poweredBySteloLogoDark from './source/powered-by-stelo-logo-dark.png'
import walkthroughCoaching from './source/walkthrough/coaching.jpg'
import walkthroughPlan from './source/walkthrough/plan.jpg'
import walkthroughCalls from './source/walkthrough/calls.jpg'
import walkthroughHealth from './source/walkthrough/health.jpg'
import nutritionistHubNutritionCoaching from './source/nutritionist-hub-nutrition-coaching.png'
import downwardCurveGraph from './source/downward_curve_graph.png'
import steloUpsell from './source/stelo_upsell.png'
import cgmActivation from './source/cgm-activation.png'
import churnMonthlyCGMOffer from './source/churn_monthly_cgm_offer.jpg'

/**
 * Onboarding Experience Images
 */
import onboardingExperienceFirstStepCompleted from './source/onboarding_experience_first_step_completed.png'
import onboardingExperienceFirstStepCompletedDark from './source/onboarding_experience_first_step_completed_dark.png'

// Weight Loss Experience Result Graphs
import weightLossExperienceResultGraph from './source/weight_loss_result_graph.png'
import weightLossExperienceResultGraphDark from './source/weight_loss_result_graph_dark.png'
import weightLossExperienceResultGraphNotEligible from './source/weight_loss_result_graph_not_eligible.png'
import weightLossExperienceResultGraphNotEligibleDark from './source/weight_loss_result_graph_not_eligible_dark.png'
// Other Onboarding Experience Result Graphs
import onboardingExperienceResultGraph from './source/onboarding_experience_result_graph.png'
import onboardingExperienceResultGraphDark from './source/onboarding_experience_result_graph_dark.png'
import onboardingExperienceResultGraphNotEligible from './source/onboarding_experience_result_graph_not_eligible.png'
import onboardingExperienceResultGraphNotEligibleDark from './source/onboarding_experience_result_graph_not_eligible_dark.png'

export const appExplorationCoachImage = {
  imageSource: appExplorationCoach,
}

export const appExplorationCoachDarkImage = {
  imageSource: appExplorationCoachDark,
}

export const appExplorationGoalsImage = {
  imageSource: appExplorationGoals,
}

export const appExplorationGoalsDarkImage = {
  imageSource: appExplorationGoalsDark,
}

export const appExplorationHomeImage = {
  imageSource: appExplorationHome,
}

export const appExplorationHomeDarkImage = {
  imageSource: appExplorationHomeDark,
}

export const appExplorationLogImage = {
  imageSource: appExplorationLog,
}

export const appExplorationLogDarkImage = {
  imageSource: appExplorationLogDark,
}

export const appExplorationNoraImage = {
  imageSource: appExplorationNora,
}

export const appExplorationNoraDarkImage = {
  imageSource: appExplorationNoraDark,
}

export const imageMeditate1Bg = {
  imageSource: imageMeditate1,
}

export const imageMeal1Bg = {
  imageSource: imageMeal1,
}

export const imageReadyToScan = {
  imageSource: imageReadyToScan1,
}

export const glucoseEducationImage = {
  imageSource: glucoseEducation,
}

export const installCgmImage = {
  imageSource: installCgm,
}

export const boxContentImage = {
  imageSource: boxContent,
}

export const calendarImage = {
  imageSource: calendar,
}

export const showerImage = {
  imageSource: shower,
}

export const dangerSignImage = {
  imageSource: dangerSign,
}

export const hourglassImage = {
  imageSource: hourglass,
}

export const bandageImage = {
  imageSource: bandage,
}

export const knowledgeBaseLightImage = {
  imageSource: knowledgeBaseLight,
}

export const knowledgeBaseDarkImage = {
  imageSource: knowledgeBaseDark,
}

export const coursesModuleDescriptionImage = {
  imageSource: coursesModuleDescription,
}

export const membershipBlurredImage = {
  imageSource: membershipBlurred,
}

export const membershipBlurredDarkImage = {
  imageSource: membershipBlurredDark,
}

export const membershipCardBgImage = {
  imageSource: membershipCardBg,
}

export const notificationsPermissionLightImage = {
  imageSource: notificationsPermissionLight,
}

export const notificationsPermissionDarkImage = {
  imageSource: notificationsPermissionDark,
}

export const healthConnectPermissionLightImage = {
  imageSource: healthConnectPermissionLight,
}

export const healthConnectPermissionDarkImage = {
  imageSource: healthConnectPermissionDark,
}

export const healthKitPermissionLightImage = {
  imageSource: healthKitPermissionLight,
}

export const healthKitPermissionDarkImage = {
  imageSource: healthKitPermissionDark,
}

export const walkthroughCoachingImage = {
  imageSource: walkthroughCoaching,
}

export const walkthroughPlanImage = {
  imageSource: walkthroughPlan,
}

export const walkthroughCallsImage = {
  imageSource: walkthroughCalls,
}

export const walkthroughHealthImage = {
  imageSource: walkthroughHealth,
}

export const goalsQuestionnaireGroupImage = {
  imageSource: goalsCircles,
}

export const arrowRightImage = {
  imageSource: arrowRight,
}

export const bluetoothImage = {
  imageSource: bluetooth,
}

export const libre1SensorBoxImage = {
  imageSource: libre1,
}

export const libre2SensorBoxImage = {
  imageSource: libre2,
}

export const libre3SensorBoxImage = {
  imageSource: libre3,
}

export const libreLogoNutrisenseImage = {
  imageSource: libreLogoNutrisense,
}

export const libre3LogoNutrisenseImage = {
  imageSource: libre3LogoNutrisense,
}

export const cgmSteloImage = {
  imageSource: cgmStelo,
}

export const cgmSteloDoubleImage = {
  imageSource: cgmSteloDouble,
}

export const cgmG6Image = {
  imageSource: cgmG6,
}

export const cgmG7Image = {
  imageSource: cgmG7,
}

export const cgmLingoImage = {
  imageSource: cgmLibre2, // Lingo has the same design as Libre 2
}

export const cgmLibre2Image = {
  imageSource: cgmLibre2,
}

export const cgmLibre3Image = {
  imageSource: cgmLibre3,
}

export const cgmLibre14dayImage = {
  imageSource: cgmLibre14day,
}

export const nutrisenseSteloConnectionImage = {
  imageSource: nutrisenseSteloConnection,
}

export const freeTrialOfferImage = {
  imageSource: freeTrialOffer,
}

export const nutritionGuidanceImage = {
  imageSource: nutritionGuidance,
}

export const nutritionIntroImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? nutritionCoachingDark : nutritionCoaching,
})

export const freeConsultationImage = {
  imageSource: freeConsultation,
}

export const sensorActivatedNutritionGuidanceImage = {
  imageSource: sensorActivatedNutritionGuidance,
}

export const nutritionistImage = {
  imageSource: nutritionist,
}

export const calendarHeartImage = {
  imageSource: calendarHeart,
}

export const blurredGlucoseChartImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? blurredGlucoseChartDark : blurredGlucoseChart,
})

export const blurredArcIndicatorsImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? blurredArcIndicatorsDark : blurredArcIndicators,
})

export const blurredDialChartImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? blurredDialChartDark : blurredDialChart,
})

export const videoCallImage = {
  imageSource: videoCall,
}

export const lingoBoxImage = {
  imageSource: lingoBox,
}

export const dexcomG6BoxImage = {
  imageSource: dexcomG6Box,
}

export const dexcomG7BoxImage = {
  imageSource: dexcomG7Box,
}

export const dexcomSteloBoxImage = {
  imageSource: dexcomSteloBox,
}

export const runnerFullImage = {
  imageSource: runnerFull,
}

export const glucoseScoreWheelImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? glucoseScoreWheelDark : glucoseScoreWheel,
})

export const glucoseChartMealImage = {
  imageSource: glucoseChartMeal,
}

export const marketplaceByosImage = {
  imageSource: marketplaceByos,
}

export const marketplaceCgmProgramsImage = {
  imageSource: marketplaceCgmPrograms,
}

export const marketplaceCoachSupportImage = {
  imageSource: marketplaceCoachSupport,
}

export const marketplaceIphoneWAppImage = {
  imageSource: marketplaceIphoneWApp,
}

export const marketplaceIphoneWAppImageVertical = {
  imageSource: marketplaceIphoneWAppVertical,
}

export const marketplaceNNImage = {
  imageSource: marketplaceNN,
}

export const marketplaceHandWPatchesImage = {
  imageSource: marketplaceHandWPatches,
}

export const marketplaceNnVideoCallsImage = {
  imageSource: marketplaceNnVideoCalls,
}

export const marketplaceNutritionistSupportImage = {
  imageSource: marketplaceNutritionistSupport,
}

export const marketplaceRunnerImage = {
  imageSource: marketplaceRunner,
}

export const marketplaceSensorsImage = {
  imageSource: marketplaceSensors,
}

export const poweredBySteloLogoImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? poweredBySteloLogoDark : poweredBySteloLogo,
})

export const nutritionistHubNutritionCoachingImage = {
  imageSource: nutritionistHubNutritionCoaching,
}

export const weightLossExperienceCompletedImage = (isDarkMode: boolean) => {
  return {
    imageSource: isDarkMode
      ? onboardingExperienceFirstStepCompletedDark
      : onboardingExperienceFirstStepCompleted,
  }
}

export const downwardCurveGraphImage = {
  imageSource: downwardCurveGraph,
}

export const weightLossExperienceResultGraphImage = (
  isDarkMode: boolean,
  isInsuranceEligible: boolean,
  isWeightLoss: boolean,
) => {
  // For the weight loss experience, the graph is different
  if (isWeightLoss) {
    if (isInsuranceEligible) {
      return {
        imageSource: isDarkMode
          ? weightLossExperienceResultGraphDark
          : weightLossExperienceResultGraph,
      }
    }

    return {
      imageSource: isDarkMode
        ? weightLossExperienceResultGraphNotEligibleDark
        : weightLossExperienceResultGraphNotEligible,
    }
  }

  // Other experiences use the onboarding experience graph
  if (isInsuranceEligible) {
    return {
      imageSource: isDarkMode
        ? onboardingExperienceResultGraphDark
        : onboardingExperienceResultGraph,
    }
  }

  return {
    imageSource: isDarkMode
      ? onboardingExperienceResultGraphNotEligibleDark
      : onboardingExperienceResultGraphNotEligible,
  }
}

export const steloUpsellImage = {
  imageSource: steloUpsell,
}

export const stressManagementIntroImage = (isDarkMode: boolean) => ({
  imageSource: isDarkMode ? stressManagementDark : stressManagement,
})

export const mfpIntegrationDarkImage = {
  imageSource: mfpIntegrationDark,
}

export const mfpIntegrationLightImage = {
  imageSource: mfpIntegrationLight,
}

export const labsImage = {
  imageSource: labs,
}

export const onboardingAppFeaturesImage = {
  imageSource: onboardingAppFeatures,
}

export const onboardingStartImage = {
  imageSource: onboardingStart,
}

export const onboardingCoachingTeamImage = {
  imageSource: onboardingCoachingTeam,
}

export const onboardingLabTestingImage = {
  imageSource: onboardingLabTesting,
}

export const onboardingMicrobiomeTestImage = {
  imageSource: onboardingMicrobiomeTest,
}

export const onboardingMicrobiomeTestDarkImage = {
  imageSource: onboardingMicrobiomeTestDark,
}

export const onboardingLabTestingDarkImage = {
  imageSource: onboardingLabTestingDark,
}

export const onboardingLabPanelsImage = {
  imageSource: onboardingLabPanels,
}

export const onboardingLabPanelsDarkImage = {
  imageSource: onboardingLabPanelsDark,
}

export const onboardingInsuranceImage = {
  imageSource: onboardingInsurance,
}

export const onboardingSteloCgmImage = {
  imageSource: onboardingSteloCgm,
}

export const onboardingSteloCgmDarkImage = {
  imageSource: onboardingSteloCgmDark,
}

export const cgmActivationImage = {
  imageSource: cgmActivation,
}

export const churnMonthlyCGMOfferImage = {
  imageSource: churnMonthlyCGMOffer,
}
